/*
 * PIKA — klik/tap kdekoli na produktové kartě (2. 10. 2026).
 * Štítky na kartě (48H, PIKA DEAL, SUPER CENA, POPULÁRNÍ, NOVINKA, BESTSELLER, SKLADEM…) jsou vedle odkazu fotky/názvu,
 * ne uvnitř něj, takže klik na ně dřív nikam nevedl. Delegovaný posluchač přepošle klik na hlavní odkaz karty;
 * title (tooltip na desktopu) zůstává, protože štítky mají normální pointer-events.
 * Interaktivní prvky karty (odkazy, tlačítka, rychlý nákup, swatche, formuláře) a tažení karuselu se nechají být.
 */
(function () {
  'use strict';
  if (window.__pikaKartaKlik) return;
  window.__pikaKartaKlik = true;
  var INTER = 'a,button,input,select,textarea,label,summary,details,form,[role="button"],[role="link"],[role="checkbox"],[role="switch"],[data-pika-no-card-click]';

  function hlavniOdkaz(card) {
    return card.querySelector('.product-card__figure a[href]') || card.querySelector('.product-card__title a[href]') || card.querySelector('a[href*="/products/"]');
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || (e.button && e.button !== 0)) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('product-card');
    if (!card) return;
    var i = t.closest(INTER);
    if (i && card.contains(i)) return;
    var sel = window.getSelection && window.getSelection();
    if (sel && !sel.isCollapsed && String(sel).length > 0) return;
    var a = hlavniOdkaz(card);
    if (!a) return;
    e.preventDefault();
    a.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window, ctrlKey: e.ctrlKey, metaKey: e.metaKey, shiftKey: e.shiftKey, altKey: e.altKey }));
  });
})();
